// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14650d59","239":"bb63cf00","453":"0e164134","455":"40cc06f1"}[chunkId] + ".chunk.js";
};